export default __webpack_public_path__ + "assets/empty-state-theme-icon-7b8dac3.svg";